import { useRef, useState, useEffect, useMemo } from 'react';
import DropdownReg from '../dropdownReg/DropdownReg';
import addBoStartCity from '../../pages/supTripDateDetails/supTripDateFun/addBoStartCity';
import { ReactComponent as CloseIcon } from '../../assets/icons/trvto_close.svg';
import addBoMuBook from '../../pages/supTripDateDetails/supTripDateFun/addBoMuBook';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import {
    comfortableOptions,
    vehicleModes,
    trnOptions
} from '../../pages/supTripDateDetails/addBooking/constants/TripBookingConstant';
import { SingleDatePicker } from 'react-dates';
import CustomTrip from '../../pages/supTripDateDetails/addBooking/Customtrip';
import Price from '../../pages/supTripDateDetails/addBooking/Price';
import { toast } from 'react-toastify';
import AddWebsiteBooking from '../addWebsiteBooking/AddWebsiteBooking';
import UserDetails from '../../pages/supTripDateDetails/addBooking/UserDetails';

export default function AddBookingTrip({ packData, setAddBo, setLoading, refresh, dates, tripDates }) {
    const params = useParams();
    const [index, setIndex] = useState(0);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedDateCustom, setSelectedDateCustom] = useState(null);
    const [startFocused, setStartFocused] = useState(null);
    const isMobile = window.innerWidth < 768;
    const notAllowedDates = useRef([]);
    const bookingTypes = ['Website', 'Manual'];
    const customData = packData;
    const custom = packData?.datesType === 'custom';
    const group = packData?.group === 'vehicle';
    const backpackingFixed = packData?.group === 'backpacking' || packData?.datesType === 'fixed';
    const [muBookData, setMuBookData] = useState({
        totalSeats: 0,
        totalRooms: 0,
        startCity: '',
        pickupLocation: '',
        meetupPoint: '',
        vehicle: {
            mode: null,
            model: null,
            emptySeats: 0,
            comfortable: 'No'
        },
        userDetails: [],
        transport: '',
        bookedVia: '',
        amountPaid: {
            actual: 0,
            tax: 0,
            paid: 0,
            reserve: 0,
            total: 0,
            isReserved: false,
            isInstallment: false
        },
        ...(packData?.datesType === 'custom'
            ? {
                  customTrip: {
                      rooms: [{ id: 1, adults: 1 }],
                      vehicle: [],
                      bed: 0,
                      people: 0,
                      isGroup: false
                  }
              }
            : {}),
        datesType: packData?.datesType,
        group: packData?.group,
        amountPerSeat: 0,
        startDate: dates ? null : packData?.startDate,
        endDate: dates ? null : packData?.endDate,
        packDateId: dates ? null : params.tripDateId,
        organizerId: packData?.organizerId,
        packId: packData?._id
    });
    const [vehicleCounts, setVehicleCounts] = useState([]);
    const [priceBasedOnCity, setPriceBasedOnCity] = useState();
    const roomsOptions = Array.from(
        { length: muBookData.totalSeats > 0 ? muBookData.totalSeats : 0 },
        (_, roomIndex) => roomIndex + 1
    );
    const vehicleModeOptions = [
        ...vehicleModes,
        ...(priceBasedOnCity?.vehicle?.some((v) => v.name === 'Bike Rent') ? ['Bike Rent'] : []),
        ...(priceBasedOnCity?.vehicle?.some((v) => v.name === 'Car Rent') ? ['Car Rent'] : [])
    ];
    const startCity = useRef(
        customData.price.map(function (item) {
            return item.startCity;
        })
    );

    const pickupNames = custom
        ? customData?.price[index]?.meetupPoint?.map((loc) => loc?.name)
        : customData?.price[index]?.pickupLocation?.map((loc) => loc?.name);

    const vehicleNames = useMemo(
        () => customData.price[index].customPrice.vehicle.map((veh) => veh.name),
        [customData]
    );

    const meetupPoints = packData?.contentId?.price
        ?.find((item) => item?.startCity?.toLowerCase() === muBookData?.startCity?.toLowerCase())
        ?.meetupPoint?.map((meetupPointItem) => meetupPointItem?.name);

    useEffect(() => {
        // The notAllowedDates should be updated only when dates are of upcoming data
        if (dates?.length > 0) {
            notAllowedDates.current = dates.map((da) => {
                return moment(da);
            });
            //Dont allow coming next two days to add trip
            const today = new Date();
            const twoDates = [moment(today)];
            notAllowedDates.current = [...notAllowedDates.current, ...twoDates];
        }
        //eslint-disable-next-line
    }, [dates]);

    useEffect(() => {
        if (selectedDate) {
            const date = tripDates.find((date) => date._id === selectedDate);
            const daysToAdd = packData?.days;
            const calculatedEndDate = moment(selectedDate).add(daysToAdd, 'days');

            setMuBookData((prev) => ({
                ...prev,
                packDateId: selectedDate,
                startDate: date.startDate, // convert to ISO format
                endDate: date.endDate // also in ISO format
            }));
        }
    }, [selectedDate]);
    useEffect(() => {
        if (selectedDateCustom) {
            const daysToAdd = packData?.days;
            const calculatedEndDate = moment(selectedDateCustom).add(daysToAdd, 'days');

            setMuBookData((prev) => ({
                ...prev,
                startDate: moment(selectedDateCustom).toISOString(), // convert to ISO format
                endDate: calculatedEndDate.toISOString() // also in ISO format
            }));
        }
    }, [selectedDateCustom]);

    useEffect(() => {
        const totalAdults = muBookData?.customTrip?.rooms?.reduce((acc, prev) => acc + prev?.adults, 0);
        const totalExtraBeds = muBookData?.customTrip?.rooms?.reduce((sum, room) => {
            return sum + Math.max(0, room?.adults - 2);
        }, 0);
        setMuBookData((prevState) => ({
            ...prevState,
            customTrip: {
                ...prevState.customTrip,
                bed: totalExtraBeds,
                people: totalAdults
            }
        }));
    }, [muBookData.customTrip?.rooms]);

    const calculateTotalVehiclePrice = (MuBokvehicleArr, customPriceVehicle) => {
        const MuBokvehicle = MuBokvehicleArr.filter((MuBokvehicleArrItem) => MuBokvehicleArrItem.vehicleCount > 0);
        const totalPrice = MuBokvehicle.reduce((total, selectedItem) => {
            const matchedVehicle = customPriceVehicle.find((cv) => cv.name === selectedItem.vehicleName);
            if (!matchedVehicle) return total;
            return total + matchedVehicle.price * selectedItem.vehicleCount;
        }, 0);
        return totalPrice;
    };

    useEffect(() => {
        if (!custom && backpackingFixed) {
            if (!muBookData.startCity) return;
            if (muBookData.totalSeats === -1) {
                setMuBookData((prevState) => ({
                    ...prevState,
                    amountPaid: {
                        ...prevState.amountPaid,
                        actual: 0,
                        tax: 0,
                        total: 0,
                        reserve: 0
                    }
                }));
                return;
            }
            const getPriceBasedOnCity = packData?.price?.find(
                (priceItem) => priceItem.startCity === muBookData.startCity
            );
            if (!getPriceBasedOnCity) return;
            setPriceBasedOnCity(getPriceBasedOnCity);
            const specialPrice = packData?.price;
            let actualPrice = 0;
            let tax = 0;
            let total = 0;
            let reservePrice = 0;
            if (specialPrice?.actual > 0 && specialPrice?.tax > 0 && specialPrice?.reserve > 0) {
                actualPrice = specialPrice.actual * muBookData.totalSeats;
                tax = specialPrice.tax * muBookData.totalSeats;
                total = actualPrice + tax;
                reservePrice = specialPrice.reserve * muBookData.totalSeats;
            } else {
                const withoutTransportPrice = packData?.contentId?.withoutTransportPrice ?? 0;
                const getVehiclePriceData = getPriceBasedOnCity?.vehicle?.find(
                    (vehicleItem) => vehicleItem?.name === muBookData.vehicle.mode
                );
                const totalVehiclePrice = getVehiclePriceData?.price;
                const roomsCount = muBookData.totalRooms > 0 ? muBookData.totalRooms : 0;
                const roomPrice = (getPriceBasedOnCity?.price?.room ?? 0) * roomsCount;
                actualPrice =
                    getPriceBasedOnCity?.price?.actual * muBookData.totalSeats +
                    roomPrice +
                    withoutTransportPrice +
                    (totalVehiclePrice || 0);
                tax = getPriceBasedOnCity?.price?.tax * muBookData.totalSeats;
                total = actualPrice + tax;
                reservePrice = getPriceBasedOnCity?.price?.reserve * muBookData.totalSeats || 0;
            }
            setMuBookData((prevState) => ({
                ...prevState,
                amountPaid: {
                    ...prevState.amountPaid,
                    actual: actualPrice,
                    tax: tax,
                    total: total,
                    reserve: reservePrice
                }
            }));
        }
    }, [packData, muBookData.startCity, muBookData.totalSeats, muBookData.totalRooms, muBookData.vehicle.mode]);

    useEffect(() => {
        if (custom) {
            if (!muBookData.startCity) return;
            const getPriceBasedOnCity = customData?.price?.find(
                (priceItem) => priceItem.startCity === muBookData.startCity
            );

            if (!getPriceBasedOnCity) return;
            setPriceBasedOnCity(getPriceBasedOnCity);

            const perPerson = getPriceBasedOnCity?.customPrice?.perPerson || 0;
            const bedPrice = getPriceBasedOnCity?.customPrice?.bed || 0;
            const roomPrice = getPriceBasedOnCity?.customPrice?.room || 0;
            const groupPrice = getPriceBasedOnCity?.customPrice?.groupPrice || 0;
            const reservePrice = getPriceBasedOnCity?.customPrice?.reserve || 0;

            const totalPersonPrice = Math.round(
                perPerson * muBookData.customTrip.people + bedPrice * muBookData.customTrip.bed
            );

            const totalRoomPrice = Math.round(roomPrice * (muBookData.customTrip.rooms?.length || 0));
            const totalVehiclePrice = calculateTotalVehiclePrice(
                muBookData.customTrip.vehicle,
                getPriceBasedOnCity?.customPrice?.vehicle
            );
            const totalReservePrice = reservePrice * muBookData.customTrip.people;

            const actualPrice = !muBookData?.customTrip?.isGroup
                ? totalPersonPrice + totalRoomPrice + totalVehiclePrice
                : groupPrice * muBookData.customTrip.people;
            const tax = Math.round(actualPrice * 0.05);
            const amountPaidTotal = actualPrice + tax;

            setMuBookData((prevState) => ({
                ...prevState,
                totalSeats: muBookData.customTrip.people,
                amountPaid: {
                    ...prevState.amountPaid,
                    actual: actualPrice,
                    tax: tax,
                    total: amountPaidTotal,
                    reserve: totalReservePrice
                },
                amountPerSeat: getPriceBasedOnCity?.customPrice?.perPerson
            }));
        }
    }, [
        muBookData?.startCity,
        muBookData.customTrip?.rooms,
        muBookData.customTrip?.people,
        muBookData.customTrip?.vehicle,
        muBookData.customTrip?.bed,
        muBookData.customTrip?.isGroup
    ]);

    const isDayBlocked = (day) => {
        return notAllowedDates.current.some((notAllowedDate) => notAllowedDate.isSame(day, 'day'));
    };

    function handleUser(e, index) {
        setMuBookData((prevState) => ({
            ...prevState,
            userDetails: prevState?.userDetails?.length
                ? prevState.userDetails.map((obj, objIndex) =>
                      objIndex === index ? { ...obj, [e.target.name]: e.target.value } : obj
                  )
                : [{ [e.target.name]: e.target.value }]
        }));
    }

    function handleAmount(e, type, number = true) {
        const name = e.target.name;
        const value = number ? Number(e.target.value) : e.target.value;
        setMuBookData((prevState) => ({
            ...prevState,
            [type]: {
                ...prevState[type],
                [name]: value
            }
        }));
    }

    function handleVehicle(e) {
        const name = e.target.name;
        const value = e.target.value;
        setMuBookData((prevState) => ({
            ...prevState,
            vehicle: {
                ...prevState.vehicle,
                [name]: value
            }
        }));
    }

    useEffect(() => {
        const isBackpackingFixed =
            packData?.contentId?.group === 'backpacking' && packData?.contentId?.datesType === 'fixed';

        if (!isBackpackingFixed && trnOptions?.length > 0 && !muBookData.transport) {
            console.log('Prefilling transport with:', trnOptions[0]);
            setMuBookData((prev) => ({
                ...prev,
                transport: trnOptions[0]
            }));
        }
    }, [packData, trnOptions]);
    console.log(muBookData);
    return (
        <div>
            <DropdownReg
                label='Booking Type'
                name='bookedVia'
                options={bookingTypes}
                value={muBookData.bookedVia}
                req={true}
                setFormData={setMuBookData}
            />
            {muBookData.bookedVia === 'Website' && (
                <AddWebsiteBooking muBookData={muBookData} setMuBookData={setMuBookData} />
            )}

            <div className='orgAddBoSubDiv'>
                {packData?.datesType === 'fixed' && (
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Start Date</label>
                        <div className='dropRegInputDiv'>
                            <select
                                name='date'
                                id='date'
                                className='dropRegSelect'
                                value={selectedDate}
                                onChange={(e) => {
                                    setSelectedDate(e.target.value);
                                }}
                            >
                                <option value=''>Select Date</option>
                                {tripDates.map((date) => (
                                    <option value={date._id} key={date._id}>
                                        {date.startDate.split('T')[0]}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>Start City</label>
                    <div className='dropRegInputDiv'>
                        <select
                            value={muBookData.startCity}
                            name='startCity'
                            onChange={(e) => addBoStartCity(e, setMuBookData, startCity.current, setIndex)}
                            required={true}
                            className='dropRegSelect'
                        >
                            <option value='-1'>Select</option>
                            {startCity.current.map(function (val, typeIndex) {
                                return (
                                    <option key={typeIndex} value={val}>
                                        {val}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                {custom && (
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Start Date</label>
                        <div className='dropRegInputDiv'>
                            <SingleDatePicker
                                withPortal={isMobile}
                                date={selectedDateCustom}
                                onDateChange={(date) => {
                                    if (!date) return;
                                    const tripDuration = packData?.days;
                                    for (let i = 1; i < tripDuration; i++) {
                                        const nextDate = moment(date).add(1, 'day');
                                        if (isDayBlocked(nextDate)) {
                                            toast.error(
                                                `You cannot select this start date (${nextDate.format('DD-MM-YYYY')}) is blocked`
                                            );
                                            return;
                                        }
                                    }

                                    setSelectedDateCustom(date);
                                }}
                                displayFormat='DD-MM-YYYY'
                                focused={startFocused}
                                onFocusChange={({ focused }) => setStartFocused(focused)}
                                numberOfMonths={1}
                                isDayBlocked={isDayBlocked}
                                isOutsideRange={(day) => day.isBefore(moment(), 'day')} // Disable past dates
                                showDefaultInputIcon={true} // shows calendar icon
                                readOnly={true}
                            />
                        </div>
                    </div>
                )}
                {packData?.contentId?.group === 'vehicle' && packData?.contentId?.datesType === 'fixed' ? (
                    <DropdownReg
                        label='Meetup Point'
                        name='meetupPoint'
                        options={meetupPoints || []}
                        value={muBookData.meetupPoint}
                        req={true}
                        setFormData={setMuBookData}
                        disabled={!muBookData?.startCity}
                    />
                ) : (
                    <DropdownReg
                        label='Pickup Location'
                        name='pickupLocation'
                        options={pickupNames || []}
                        value={muBookData.pickupLocation}
                        req={true}
                        setFormData={setMuBookData}
                        disabled={!muBookData?.startCity}
                    />
                )}

                {packData?.contentId?.withoutTransportPrice > 0 &&
                    packData?.contentId?.datesType === 'fixed' &&
                    packData?.contentId?.group !== 'vehicle' && (
                        <DropdownReg
                            label='Transport'
                            name='transport'
                            options={
                                packData?.contentId?.group === 'backpacking' &&
                                packData?.contentId?.datesType === 'fixed'
                                    ? trnOptions
                                    : trnOptions
                            }
                            value={
                                packData?.contentId?.group === 'backpacking' &&
                                packData?.contentId?.datesType === 'fixed'
                                    ? muBookData.transport
                                    : trnOptions[0]
                            }
                            req={true}
                            setFormData={setMuBookData}
                            disabled={
                                !(
                                    packData?.contentId?.group === 'backpacking' &&
                                    packData?.contentId?.datesType === 'fixed'
                                )
                            }
                        />
                    )}
                {(packData?.contentId?.group === 'vehicle' || custom) && (
                    <DropdownReg
                        label='Transport'
                        name='transport'
                        options={
                            packData?.contentId?.group === 'backpacking' && packData?.contentId?.datesType === 'fixed'
                                ? trnOptions
                                : trnOptions
                        }
                        value={
                            packData?.contentId?.group === 'backpacking' && packData?.contentId?.datesType === 'fixed'
                                ? muBookData.transport
                                : trnOptions[0]
                        }
                        req={true}
                        setFormData={setMuBookData}
                        disabled={
                            !(
                                packData?.contentId?.group === 'backpacking' &&
                                packData?.contentId?.datesType === 'fixed'
                            )
                        }
                    />
                )}
                {group && (
                    <>
                        <DropdownReg
                            label='Select Vehicle'
                            name='mode'
                            options={vehicleModeOptions}
                            value={muBookData?.vehicle.mode}
                            req={true}
                            nest='vehicle'
                            setFormData={setMuBookData}
                        />
                        {['Self Bike', 'Self Car'].includes(muBookData?.vehicle.mode) && (
                            <>
                                <div className='dropRegDiv'>
                                    <label htmlFor='vehicleModel' className='dropRegLabel'>
                                        Model
                                    </label>
                                    <div className='dropRegInputDiv'>
                                        <input
                                            id='vehicleModel'
                                            name={'model'}
                                            type='text'
                                            className='dropRegSelect'
                                            placeholder={
                                                muBookData?.vehicle.mode === 'Self Bike'
                                                    ? 'e.g. Royal Enfield Classic'
                                                    : 'e.g. Maruti Swift'
                                            }
                                            value={muBookData?.vehicle.model}
                                            onChange={(e) => handleVehicle(e, setMuBookData)}
                                        />
                                    </div>
                                </div>

                                <div className='dropRegDiv'>
                                    <label style={{ marginTop: 10 }} htmlFor='vehicleModel' className='dropRegLabel'>
                                        Empty Seats
                                    </label>
                                    <div className='dropRegInputDiv'>
                                        <input
                                            id='emptySeats'
                                            name={'emptySeats'}
                                            type='number'
                                            className='dropRegSelect'
                                            placeholder={'e.g. 2'}
                                            value={muBookData?.vehicle.emptySeats}
                                            onChange={(e) => handleVehicle(e, setMuBookData)}
                                        />
                                    </div>
                                </div>

                                <DropdownReg
                                    label='Comfortable'
                                    name='comfortable'
                                    options={comfortableOptions}
                                    value={muBookData?.vehicle.comfortable}
                                    req={true}
                                    nest='vehicle'
                                    setFormData={setMuBookData}
                                />
                            </>
                        )}
                    </>
                )}

                {custom && (
                    <CustomTrip
                        muBookData={muBookData}
                        setMuBookData={setMuBookData}
                        vehicleNames={vehicleNames}
                        handleAmount={handleAmount}
                        vehicleCounts={vehicleCounts}
                        setVehicleCounts={setVehicleCounts}
                    />
                )}
                <Price
                    muBookData={muBookData}
                    setMuBookData={setMuBookData}
                    handleAmount={handleAmount}
                    custom={custom}
                    priceBasedOnCity={priceBasedOnCity}
                    roomsOptions={roomsOptions}
                />
                <UserDetails
                    muBookData={muBookData}
                    handleUser={handleUser}
                    custom={custom}
                    totalSeats={muBookData.totalSeats}
                />
                <div className='orgAddBoBtn'>
                    <button
                        type='button'
                        name='ManualBookingSubmit'
                        className='orgAddBoSubmit blueBtn'
                        onClick={() => {
                            muBookData.packId.datesType === 'custom'
                                ? addBoMuBook({
                                      muBookData,
                                      setAddBo,
                                      setLoading,
                                      refresh,
                                      packData
                                  })
                                : addBoMuBook({
                                      muBookData,
                                      tripDateId: params.tripDateId,
                                      setAddBo,
                                      setLoading,
                                      refresh,
                                      packData
                                  });
                        }}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
}
